var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{style:(Object.assign({}, _vm.styleObj, {color: _vm.color}))},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.icon)?_c('font-awesome-icon',{style:(_vm.iconStyle),attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }